import { createSelector } from '@ngrx/store';
import { ManpowerSettingStateInterface } from './settingsmanpower.state';
import { getManpowerState } from '../setting.selectors';

export const getManpowerSettings = createSelector(
  getManpowerState,
  (state: ManpowerSettingStateInterface) => state
);
